import React, { useState } from 'react';
import SimpleDialog, { SimpleDialogProps } from '../SimpleDialog/SimpleDialog';
import { useTranslation } from 'react-i18next';
import { AppState } from '../../../store/state';
import { AppDispatch } from '../../../store/store';
import { connect } from 'react-redux';
import { InputText } from '../../ui';
import RangeSlider from '../../ui/inputs/RangeSlider/RangeSlider';
import { CreateSubsetBid } from '../../../store/bid/types';
import bidSlice from '../../../store/bid/slice';

interface Props extends SimpleDialogProps {
  rowId: number;
  createSubsetBidAction: (data: CreateSubsetBid) => void;
}

const CreateSubsetBidDialog: React.FC<Props> = ({ rowId, createSubsetBidAction, ...rest }) => {
  const { t, i18n } = useTranslation();

  const [data, setData] = useState<{
    numSubmissions?: number;
    pctRand: number;
  }>({
    numSubmissions: undefined,
    pctRand: 0,
  });

  return (
    <SimpleDialog
      {...rest}
      open={true}
      title={t('Create subset bid')}
      disableOkButton={!data.numSubmissions || data.numSubmissions < 0}
      handleOk={() => {
        if (data.numSubmissions) {
          createSubsetBidAction({
            person_role_id: rowId,
            num_submissions: data.numSubmissions,
            pct_random: data.pctRand / 100,
          });
        }
      }}
    >
      <InputText
        type="number"
        label={t('Number of submissions')}
        onChange={(event) => setData({ ...data, numSubmissions: parseInt(event.target.value) })}
      ></InputText>
      <div className="mt-5"></div>
      <RangeSlider
        label={t('Percentage of randomization')}
        onChange={(value) => setData({ ...data, pctRand: value })}
      />
    </SimpleDialog>
  );
};

const mapStateToProps = (state: AppState) => ({});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  createSubsetBidAction: (data: CreateSubsetBid) => dispatch(bidSlice.actions.CREATE_SUBSET(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateSubsetBidDialog);
